import React, { useEffect, useState } from "react";

import Footer from "./Footer";
import TopBar from "./Topbar";

const AffiliatedPartners = () => {
    const [partners, setPartners] = useState([]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/affiliate-partners`, {
            credentials: "include",
        })
            .then((response) => response.json())
            .then((data) => {
                if(Array.isArray(data?.partners) && data.partners.length) {
                    setPartners(data.partners);
                } else {
                    setPartners([]);
                }
            })
            .catch(() => {
                setPartners([]);
            });
    }, []);

    const getPartnerImage = (partner) => {
        const image = partner.image || partner.logo || "";

        if(image.startsWith("/uploads/")) {
            return `${process.env.REACT_APP_BACKEND_URL}${image}`;
        }

        return image;
    };

    return (
        <>
            <TopBar />
            <main className="bg-white">
                <section className="relative inset-0 w-full bg-black/50">
                    <img
                        src="/images/PartnersImage.jpg"
                        alt="Hero Section"
                        className="w-full h-[700px] md:h-[600px] lg:h-[500px] object-cover object-[50%_80%] md:object-[50%_70%] lg:object-[20%_25%] brightness-75"
                    />
                    {/* Top-Centered Title */}
                    <div className="absolute inset-0 top-0 z-10 w-full px-4 mt-2 text-center transform -translate-x-1/2 left-1/2">
                        <h1
                            className="text-3xl md:text-5xl font-semibold text-white leading-tight md:leading-[4.5rem] drop-shadow-lg font-poppins"
                            style={{ fontFamily: "Poppins" }}
                        >
                            Behind Every Bold Founder?
                        </h1>
                        <h1
                            className="text-3xl md:text-5xl font-semibold text-white leading-tight md:leading-[4.5rem] drop-shadow-lg font-poppins mt-2"
                            style={{ fontFamily: "Poppins" }}
                        >
                            A Smart, Strategic Partner
                        </h1>
                    </div>

                    {/* Bottom overlay card with text */}
                    <div className="absolute bottom-[1px] md:bottom-[10px] w-full px-6 z-10">
                        <div className="bg-navy/70 text-white max-w-5xl mx-auto rounded-md shadow-lg px-6 py-3 text-center">
                            <p
                                className="max-w-3xl mx-auto mb-4 text-sm md:text-base text-white/90"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 400,
                                }}
                            >
                                No one builds something extraordinary alone.
                                That&apos;s why we&apos;ve curated a trusted
                                circle of experts in legal, marketing,
                                accounting, and compliance<span className="inline-block w-5 border-t-2 border-current align-middle mx-2" />partners who
                                understand the unique needs of women
                                entrepreneurs and the fast-moving world of
                                crowdfunding. Whether you&apos;re launching your
                                first campaign or scaling your next big idea,
                                these are the advisors we rely on to help
                                founders rise with clarity, confidence, and
                                support.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Partners Grid */}
                <section className="relative z-20 max-w-6xl px-4 py-16 mx-auto -mt-30">
                    <div className="grid grid-cols-1 gap-8 md:grid-cols-3 lg:gap-16 xl:gap-26">
                        {partners.map((partner, idx) => (
                            <div
                                key={partner.id || idx}
                                className="border-2 border-navy rounded-md p-6 flex flex-col items-center bg-white shadow-md"
                            >
                                <div className="flex items-center justify-center w-24 h-24 mb-4 border border-gray-300 rounded-md bg-gray-50">
                                    {getPartnerImage(partner) ? (
                                        <img
                                            src={getPartnerImage(partner)}
                                            alt={
                                                partner.affiliateName
                                            }
                                            className="object-contain w-20 h-20"
                                        />
                                    ) : (
                                        <span
                                            className="text-xs text-center text-gray-500"
                                            style={{
                                                fontFamily:
                                                    "'Poppins', sans-serif",
                                                fontWeight: 400,
                                            }}
                                        >
                                            COMPANY LOGO
                                        </span>
                                    )}
                                </div>
                                <h2
                                    className="text-xl font-semibold text-navy mb-2 text-center"
                                    style={{ fontFamily: "Poppins" }}
                                >
                                    {partner.affiliateName}
                                </h2>
                                <p
                                    className="mb-4 text-sm text-center text-gray-700"
                                    style={{
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 400,
                                    }}
                                >
                                    {partner.description || partner.desc || ""}
                                </p>
                                <a
                                    href={
                                        partner.websiteLink ||
                                        partner.website ||
                                        "#"
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="bg-navy text-white font-semibold px-6 py-2 rounded w-full text-center hover:bg-navy-2 transition"
                                    style={{ fontFamily: "Poppins" }}
                                >
                                    Visit Website
                                </a>
                            </div>
                        ))}
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
};

export default AffiliatedPartners;
